import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { UserAccountFeature } from '../../../enums/user-account-feature.enum';

@Component({
    standalone: false,
    selector: 'por-permission-checkbox-renderer',
    templateUrl: './permission-checkbox.html'
})
export class PermissionCheckboxRendererComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    checked = false;
    permissionKey!: UserAccountFeature;

    public contact!: ContactResponse;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.permissionKey = params.colDef?.cellRendererParams?.permissionKey;
        this.contact = { ...params.data };

        const permissions = this.contact.permissions ?? {};
        this.checked = !!permissions[this.permissionKey];
    }

    onCheckboxChange(isChecked: boolean): void {
        if (this.params.context && this.params.context.componentParent) {
            this.params.context.componentParent.onCheckboxChange({
                email: this.contact.email,
                customerId: this.contact.customerId,
                enabled: isChecked,
                permission: this.permissionKey
            });
        }
    }

    refresh(): boolean {
        return false;
    }
}
